// core/scanner.ts
import { EiWidget } from '@/core/EiWidget';
import { hasInstance, setInstance } from '@/core/registry';
import type { Config } from '@/types/global';
import { allInstances } from '@/core/registry';

export function createScanner(
    config: Config,
    opts: Omit<ConstructorParameters<typeof EiWidget>[1], 'key' | 'config'> = {}
) {
    function scan(scope: ParentNode): HTMLElement[] {
        return Array.from(scope.querySelectorAll<HTMLElement>(`[${config.mountAttr}]`));
    }

    async function reconcile(scope: ParentNode) {
        window.easti.log.info('Reconciling widgets in scope', scope);
        const els = scan(scope);
        const desired = new Set(els);

        // 1) Unmount tracked instances whose element is no longer desired (in this scope)
        for (const { el, widget } of allInstances()) {
            if (!desired.has(el)) {
                await widget.unmount();
            }
        }

        // 2) Ensure each desired element has an instance
        for (const el of els) {
            const key = el.getAttribute(config.mountAttr)!;
            if (!hasInstance(el)) {
                const widget = new EiWidget(el, { ...opts, key, config });
                setInstance(el, widget);
                widget.mount();
            }
        }
    }

    return { scan, reconcile };
}
